import { Paper, Typography, Box } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { formatMoney } from '../utils';

const COLORS_MAP = {
  'Paid Revenue': '#1565c0',
  'Organic Revenue': '#43a047',
  'Paid Calls': '#1565c0',
  'Organic Calls': '#43a047',
};

const PaidOrganicPie = ({ totals }) => {
  const revenueData = [
    { name: 'Paid Revenue', value: totals.paid.totalRevenue },
    { name: 'Organic Revenue', value: totals.organic.totalRevenue },
  ].filter((d) => d.value > 0);

  const callsData = [
    { name: 'Paid Calls', value: totals.paid.calls },
    { name: 'Organic Calls', value: totals.organic.calls },
  ].filter((d) => d.value > 0);

  const proposalData = [
    { name: 'HIC Proposals', value: totals.overall.hicProposals, fill: '#0d3c61' },
    { name: 'HIC Sold', value: totals.overall.hicSold, fill: '#4caf50' },
    { name: 'SVC Proposals', value: totals.overall.svcProposals, fill: '#7b1fa2' },
  ].filter((d) => d.value > 0);

  return (
    <Paper sx={{ p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#0d3c61' }}>Paid vs Organic</Typography>

      <Box sx={{ flex: 1, minHeight: 200 }}>
        <Typography variant="subtitle2" sx={{ textAlign: 'center', color: '#666', mb: 0.5 }}>Revenue Split</Typography>
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={revenueData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={75}
              innerRadius={40}
              label={({ name, value }) => formatMoney(value)}
              labelLine
              fontSize={11}
            >
              {revenueData.map((entry, i) => <Cell key={i} fill={COLORS_MAP[entry.name]} />)}
            </Pie>
            <Tooltip formatter={(v) => formatMoney(v)} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      </Box>

      <Box sx={{ flex: 1, minHeight: 200 }}>
        <Typography variant="subtitle2" sx={{ textAlign: 'center', color: '#666', mb: 0.5 }}>Calls Split</Typography>
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={callsData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={75}
              innerRadius={40}
              label={({ value }) => value}
              labelLine
              fontSize={11}
            >
              {callsData.map((entry, i) => <Cell key={i} fill={COLORS_MAP[entry.name]} />)}
            </Pie>
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      </Box>

      {proposalData.length > 0 && (
        <Box sx={{ minHeight: 200 }}>
          <Typography variant="subtitle2" sx={{ textAlign: 'center', color: '#666', mb: 0.5 }}>Proposals</Typography>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={proposalData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={75}
                innerRadius={40}
                label={({ name, value }) => `${value}`}
                labelLine
                fontSize={11}
              >
                {proposalData.map((entry, i) => <Cell key={i} fill={entry.fill} />)}
              </Pie>
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Paper>
  );
};

export default PaidOrganicPie;
